import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

interface PropTypes extends HTMLAttributes<HTMLDivElement> {
  bgImage?: string;
  bgColor?: string;
  bgOverlayColor?: string;
  containerSize?: 'small' | 'normal';
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

export default class Section extends React.Component<PropTypes> {
  static defaultProps = {
    containerSize: 'normal',
  };

  render() {
    const {
      props: {
        bgImage,
        bgColor,
        bgOverlayColor,
        className,
        containerClassName,
        children,
        containerSize,
        ...htmlAttr
      },
    } = this;

    const container = classNames(
      `container${this.props.containerSize === 'normal' ? '' : '-small'}`,
      containerClassName,
    );
    const classes = classNames('section section-box', className);
    return (
      <div {...htmlAttr} className={classes}>
        {bgImage ? (
          <div className="section-cover-wrap">
            <div className="section-cover">
              <img src={bgImage} alt="Early bird" />
            </div>
          </div>
        ) : null}
        {bgColor ? (
          <div className="boxlet-bg-color" style={{ background: bgColor }} />
        ) : null}
        {bgColor ? (
          <div
            className="section-overlay"
            style={{ background: bgOverlayColor }}
          />
        ) : null}

        <div className="section-content">
          <div className={container}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}
